import { render, staticRenderFns } from "./AudiLayout.vue?vue&type=template&id=2aefc7c0&"
import script from "./AudiLayout.vue?vue&type=script&lang=js&"
export * from "./AudiLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QSpace,QMenu,QList,QItem,QItemSection,QSeparator,QDrawer,QPageContainer,QScrollObserver,QFooter,QBtnGroup,QDialog,QCard,QCardSection,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QSpace,QMenu,QList,QItem,QItemSection,QSeparator,QDrawer,QPageContainer,QScrollObserver,QFooter,QBtnGroup,QDialog,QCard,QCardSection,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
